// Premium included with the team (dev call, 2026-10-07; notes 10/19): an
// athlete on a team whose coach is on a paid plan, on a team CACHE sponsors
// (a team plan), or linked by a team code that waives the fee is never asked
// to upgrade. The server works the coverage out on every read
// (users/entitlements.py) and sends it beside the effective entitlement, on
// GET /entitlement/ (the Redux entitlement slice) and on the onboarding state:
//   coverage = { coachName, teamName, planName, teamId, via, kind, sponsorName } or null
// kind is 'coach', 'team_plan' or 'team_code' (entitlements.PUBLIC_COVERAGE_FIELDS:
// the coach's email and plan key stay on the server and in admin payloads).

// The coverage a Redux entitlement slice or an onboarding state carries,
// else null.
export const coverageOf = (source) => {
  const coverage = source?.coverage;
  return coverage && typeof coverage === 'object' ? coverage : null;
};

// What includes the Premium. A payload from before team plans carries no
// kind: a coach's plan.
export const coverageKind = (coverage) => {
  const kind = coverage?.kind;
  return kind === 'team_plan' || kind === 'team_code' ? kind : 'coach';
};

// "Ridgeview Elite's", "Hillcrest Boosters'".
export const possessive = (name) => (/s$/i.test(name) ? `${name}'` : `${name}'s`);

// The line every athlete surface shows: "Premium is included with Vic
// Coach's Longhorns plan." A missing coach or team name reads as "your
// coach's" or "team". A team plan names its sponsor ("Premium is included
// with Ridgeview Elite's team plan."), a team code says so.
export const coverageSentence = (coverage) => {
  const kind = coverageKind(coverage);
  if (kind === 'team_code') return 'Premium is included with your team code.';
  if (kind === 'team_plan') {
    const sponsor = String(coverage?.sponsorName || coverage?.teamName || '').trim();
    return sponsor ? `Premium is included with ${possessive(sponsor)} team plan.` : "Premium is included with your team's plan.";
  }
  const coach = String(coverage?.coachName || '').trim();
  const team = String(coverage?.teamName || '').trim();
  if (!coach && !team) return "Premium is included with your team's plan.";
  return `Premium is included with ${coach ? `${coach}'s` : "your coach's"} ${team || 'team'} plan.`;
};
